<script lang="ts">
  import type { Section } from '$lib/section/SectionType.js';
  import PageContent from './PageContent.svelte';
  import Breadcrumb from '$lib/breadcrumbs/Breadcrumb.svelte';
	import type { PageProps } from '$lib/metadataTypes/MetaTypes';
	import { page } from '$app/state';
	  
	let { data }: PageProps = $props();  
  let showDetails: boolean = $state(false);
  
  
						const sections = $state<Section[]>([
																{id: "the-freon-core-interfaces-1", title: "The Freon Core Interfaces", visible: false, ref: '#the-freon-core-interfaces-1'},
{id: "frenode-2", title: "FreNode", visible: false, ref: '#frenode-2'},
{id: "frenamednode-3", title: "FreNamedNode", visible: false, ref: '#frenamednode-3'},
{id: "freaction-4", title: "FreAction", visible: false, ref: '#freaction-4'},
{id: "frecustomaction-5", title: "FreCustomAction", visible: false, ref: '#frecustomaction-5'}
														]);
						
	
	// keep 'current' in parent so both Nav and Content can read it
  let current = $state(0);

  // callback to update visible elements from child
  function setVisible(id: string, isVisible: boolean) {
  	const s = sections.find((s) => s.id === id);
   	if (s) s.visible = isVisible; // $state tracks deep mutations
    const idx = sections.findIndex((s) => s.visible); // set current to the top most visible heading
    if (idx >= 0) {
       current = idx;
    }
  }
	
	// the stuff below ensures that metadata is added to the page
  const fullTitle = $derived(
    data.page.title
      ? `${data.site.title} – ${data.category.title} – ${data.page.title}`
      : `${data.site.title} – ${data.category.title}`
  );
  const description = $derived(data.page.description ?? data.category.description);
  const image = 'https://freon4dsl.dev/images/freon-banner.png';
  let canonical = $derived.by(() => {
    const p = page.url.pathname;
    const normalized = p === '/' ? '/' : p.replace(/\/$/, '');
    return `https://freon4dsl.dev${normalized}`;
  });
  const siteTags: string[] = data.site?.tags ?? [];
  const categoryTags: string[] = data.category?.tags ?? [];
  const pageTags: string[] = data.page.tags ?? [];

  // Combine tags, remove duplicates, and drop falsy values
  const tags = [...new Set([...siteTags, ...categoryTags, ...pageTags].filter(Boolean))];
  // svelte-ignore state_referenced_locally
  const jsonLd  = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "headline": fullTitle,
			"description": description,
			"url": canonical,
			"datePublished": data.page.publishedTime,
			"dateModified": data.page.modifiedTime,
      "keywords": tags.length ? tags.join(', ') : undefined,
      "image": image,
      "publisher": data?.site?.title
        ? { "@type": "Organization", name: data.site.title }
        : undefined
    };

</script>

<svelte:head>
  <!-- Basic SEO -->
  <title>{fullTitle}</title>
  <meta name="description" content={description} />
  <meta name="robots" content='index,follow' />
  <link rel="canonical" href={canonical} />
  
  {#if data.page.publishedTime}
    <meta property="article:published_time" content={data.page.publishedTime} />
  {/if}
  {#if data.page.modifiedTime}
    <meta property="article:modified_time" content={data.page.modifiedTime} />
  {/if}
  
  {#if tags}
		{#each tags as tag}
			<meta property="article:tag" content={tag} />
		{/each}
	{/if}
	<meta name="keywords" content={tags.join(', ')} />

  <!-- Open Graph -->
  <meta property="og:type" content="article" />
  <meta property="og:title" content={fullTitle} />
  <meta property="og:description" content={description} />
  <meta property="og:site_name" content={data.site.title} />
  <meta property="og:image" content={image} />
  <meta property="og:url" content={canonical} />

  <!-- Twitter -->
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={fullTitle} />
  <meta name="twitter:description" content={description} />
  <meta name="twitter:image" content={image} />
  
   <!-- JSON-LD -->
  {@html `<script type="application/ld+json">${JSON.stringify(jsonLd)}</script>`}
</svelte:head>

<div class="page-main">
  <div class='page-toc-small'>
    <p class='page-toc-small-title'>On this page ...</p>
    <button class='page-toc-small-expand-button' onclick={() => {showDetails = !showDetails}  }>
      {#if showDetails }
        <img class='page-toc-small-img' src="/icons/upload.png" alt="arrow up"/>
      {:else}
        <img class='page-toc-small-img' src="/icons/down-arrow.png" alt="arrow down"/>
      {/if}
    </button>
  </div>
    {#if showDetails }
      <div class='toc-details'>
        <ul class="page-ul">
          {#each sections as sec, index (sec)}
            <li class="page-toc-text">
              <a class:page-visible={index === current} class:page-nonvisible={index !== current} href={sec.ref}>
                {sec.title}
              </a>
            </li>
          {/each}
        </ul>
      </div>
    {/if}

	<Breadcrumb />
  <PageContent {setVisible} />
</div>

<nav class="page-toc">
  <h3 class="page-toc-title">On this page</h3>
  <ul class="page-ul">
    {#each sections as sec, index (sec)}
      <li class="page-toc-text">
        <a class:page-visible={index === current} class:page-nonvisible={index !== current} href={sec.ref}>
          {sec.title}
        </a>
      </li>
    {/each}
  </ul>
</nav>
